import { makeAutoObservable } from 'mobx'
import type { IBaseWorkflowData, IFullWorkflowData } from 'entities/Workflow/api'
import { transformWorkflowV1UISettingsToV2 } from 'entities/Workflow/utils/transformWorkflowV1UISettingsToV2'
import { type FeatureFlagsStore } from 'entities/FeatureFlags'

export type IWorkflow = Workflow

export class Workflow {
  static Create(item: IFullWorkflowData, featureFlagsStore: FeatureFlagsStore) {
    return new Workflow(item, featureFlagsStore)
  }

  private _origin!: IFullWorkflowData

  get id() {
    return this._origin.id
  }

  get name() {
    return this._origin.name
  }

  get enabled() {
    return this._origin.enabled
  }

  get createdAt() {
    return this._origin.created_at
  }

  get updatedAt() {
    return this._origin.updated_at
  }

  get executionsCount() {
    return this._origin.executions_count
  }

  get v2Data() {
    if (this._origin.ui_settings?.data) {
      return transformWorkflowV1UISettingsToV2(this._origin.ui_settings?.data.children ?? null)
    }

    return {
      definition: this._origin.definition,
      ui_settings: this._origin.ui_settings,
    }
  }

  get isInvalid() {
    return this._origin.is_invalid
  }

  get baseData(): IBaseWorkflowData {
    return {
      name: this._origin.name,
      multiple_executions: this._origin.multiple_executions,
      description: this._origin.description,
      settings: this._origin.settings ?? null,
      ...this.v2Data,
    }
  }

  constructor(item: IFullWorkflowData, private _featureFlagsStore: FeatureFlagsStore) {
    this.syncOrigin(item)
    makeAutoObservable(this)
  }

  syncOrigin(item: Partial<IFullWorkflowData>) {
    this._origin = {
      ...this._origin,
      ...item,
    }
  }
}
